import { CardTitle } from "react-migration/components/CardTitle";

export function DrawingsSelectionTitle() {
  return <CardTitle>Annotations</CardTitle>;
}
